"use client";

import * as React from "react";
import { Loader2 } from "lucide-react";

import { CopilotPopupComponent } from "@constructr-sdk/modules/aiassistant/presentation/default/components";
import { useNavigation } from "@constructr-sdk/modules/context/navigation-context";

export default function BaseNavigationLayout({
  children,
}: React.PropsWithChildren): React.JSX.Element {
  const { isLoading, showCopilot, activeOrganizationId, userDto } = useNavigation();

  return (
    <div className="flex h-screen flex-col w-full">
      <main className="flex-1 w-full min-h-0 mx-auto">
        {isLoading ? (
          <div className="flex items-center justify-center h-full">
            <div className="flex flex-col items-center gap-4">
              <Loader2 className="h-8 w-8 animate-spin text-primary-500" />
            </div>
          </div>
        ) : (
          children
        )}
      </main>
      {showCopilot && <CopilotPopupComponent userId={userDto?.id} organizationId={activeOrganizationId} />}
    </div >
  );
}
